import { Typography } from '@mui/material';
import { Translation } from 'react-i18next';
import { ProfileEditorWrapper } from '../common';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var NotificationSettingsBox = function NotificationSettingsBox(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_jsxs(ProfileEditorWrapper, {
    "data-element": "ProfileEditorWrapper",
    "data-component": "NotificationSettingsBox",
    "data-source-file": "notification-settings-box.tsx",
    children: [/*#__PURE__*/_jsx(Typography, {
      variant: "h2",
      sx: {
        mb: 5
      },
      "data-element": "Typography",
      "data-component": "NotificationSettingsBox",
      "data-source-file": "notification-settings-box.tsx",
      children: /*#__PURE__*/_jsx(Translation, {
        "data-element": "Translation",
        "data-component": "NotificationSettingsBox",
        "data-source-file": "notification-settings-box.tsx",
        children: function children(t) {
          return t('Notifications');
        }
      })
    }), children]
  });
};